/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Gps_State_No_GpsInputs */

const vi_vehicle_gps_state_no_gps = /** @type {(inputs: Vehicle_Gps_State_No_GpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xe chưa cấu hình GPS. Bấm sửa xe để chọn VnetGPS và nhập IMEI thiết bị.`)
};

/**

* @param {Vehicle_Gps_State_No_GpsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_gps_state_no_gps = /** @type {((inputs?: Vehicle_Gps_State_No_GpsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Gps_State_No_GpsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_gps_state_no_gps(inputs)
});